// src/common/localization/localization-discovery.js
window.StretchCustom = window.StretchCustom || {};
var ENABLED = Boolean(window.themeVariables?.settings?.localizationDiscoveryEnabled);
function waitForShopify(maxAttempts = 100, intervalMs = 40) {
  return new Promise((resolve) => {
    let n = 0;
    const tick = () => {
      if (window.Shopify?.routes?.root) {
        resolve(window.Shopify);
        return;
      }
      if (++n >= maxAttempts) {
        resolve(null);
        return;
      }
      setTimeout(tick, intervalMs);
    };
    tick();
  });
}
if (!ENABLED) {
  window.StretchCustom.localizationDiscoveryResult = null;
  window.StretchCustom.localizationDiscoveryPromise = Promise.resolve({
    skipped: true,
    reason: "disabled"
  });
} else {
  window.StretchCustom.localizationDiscoveryPromise = (async () => {
    const shopify = await waitForShopify();
    if (!shopify?.routes?.root) {
      const payload = { ok: false, error: "shopify_not_ready" };
      window.StretchCustom.localizationDiscoveryResult = payload;
      console.warn("[Stretch] localization discovery:", payload.error);
      return payload;
    }
    const root = shopify.routes.root;
    const country = encodeURIComponent(shopify.country ?? "");
    const language = encodeURIComponent(shopify.language ?? "");
    const url = `${root}browsing_context_suggestions.json?country[enabled]=true&country[exclude]=${country}&language[enabled]=true&language[exclude]=${language}`;
    try {
      const response = await fetch(url);
      if (!response.ok) {
        const payload2 = { ok: false, error: `http_${response.status}` };
        window.StretchCustom.localizationDiscoveryResult = payload2;
        console.warn("[Stretch] localization discovery:", payload2.error);
        return payload2;
      }
      const data = await response.json();
      console.log("[Stretch] localization discovery:", data);
      const payload = { ok: true, data };
      window.StretchCustom.localizationDiscoveryResult = payload;
      document.documentElement.dispatchEvent(
        new CustomEvent("stretch:localization-discovery", {
          detail: data,
          bubbles: false
        })
      );
      return payload;
    } catch (error) {
      const payload = { ok: false, error: String(error) };
      window.StretchCustom.localizationDiscoveryResult = payload;
      console.warn("[Stretch] localization discovery:", payload.error);
      return payload;
    }
  })();
}

// src/common/localization/musp-localization-guard.js
(function runMuspLocalizationGuard() {
  const iso = window.themeVariables?.settings?.currentCountryIso;
  if (iso == null || String(iso).trim() === "") {
    return;
  }
  const applyIfMismatch = (data) => {
    if (!data || typeof data !== "object") return;
    const handle = data.detected_values?.country?.handle;
    if (handle == null || String(handle).trim() === "") {
      return;
    }
    const normalizedHandle = String(handle).trim().toUpperCase();
    const normalizedIso = String(iso).trim().toUpperCase();
    if (normalizedHandle !== normalizedIso) {
      document.documentElement.classList.add("stretch-musp--localization-mismatch");
    }
  };
  document.documentElement.addEventListener("stretch:localization-discovery", (event) => {
    try {
      applyIfMismatch(event.detail);
    } catch (e) {
      console.warn("[Stretch] mUSP localization guard (event):", e);
    }
  });
  (async () => {
    try {
      const result = await window.StretchCustom.localizationDiscoveryPromise;
      if (result?.skipped || !result?.ok || !result?.data) {
        return;
      }
      applyIfMismatch(result.data);
    } catch (e) {
      console.warn("[Stretch] mUSP localization guard:", e);
    }
  })();
})();

// src/common/utilities/custom-utils.js
window.StretchCustom.formatPrice = function(cents, currency = "USD") {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency
  }).format(cents / 100);
};
window.StretchCustom.truncate = function(text, maxLength = 100) {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + "...";
};
window.StretchCustom.uniqueId = function(prefix = "id") {
  return `${prefix}-${Math.random().toString(36).substr(2, 9)}`;
};
window.StretchCustom.CustomBackdrop = /* @__PURE__ */ (() => {
  let backdrop = null;
  let showFrame = null;
  const create = () => {
    if (backdrop) return backdrop;
    backdrop = document.createElement("div");
    backdrop.className = "custom-backdrop";
    backdrop.setAttribute("data-backdrop", "custom");
    document.body.appendChild(backdrop);
    return backdrop;
  };
  const cancelPendingShow = () => {
    if (showFrame !== null) {
      cancelAnimationFrame(showFrame);
      showFrame = null;
    }
  };
  const show = () => {
    const element = create();
    cancelPendingShow();
    showFrame = requestAnimationFrame(() => {
      showFrame = null;
      element.setAttribute("data-visible", "true");
    });
  };
  const hide = () => {
    cancelPendingShow();
    if (!backdrop) return;
    backdrop.removeAttribute("data-visible");
  };
  const init2 = () => {
    create();
  };
  return {
    show,
    hide,
    init: init2,
    element: () => backdrop
  };
})();
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    window.StretchCustom.CustomBackdrop.init();
  });
} else {
  window.StretchCustom.CustomBackdrop.init();
}

// src/common/behavior/responsive-header.js
import { mediaQueryListener } from "theme";
var initResponsiveHeader = () => {
  const sections = document.querySelectorAll("[data-disable-transparent-mobile]");
  if (sections.length === 0) return;
  const updateAllSections = (isDesktop2) => {
    sections.forEach((section) => {
      if (isDesktop2) {
        section.setAttribute("allow-transparent-header", "");
      } else {
        section.removeAttribute("allow-transparent-header");
      }
    });
  };
  const isDesktop = window.matchMedia("(min-width: 1000px)").matches;
  updateAllSections(isDesktop);
  mediaQueryListener("md", (e) => {
    updateAllSections(e.matches);
  });
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initResponsiveHeader);
} else {
  initResponsiveHeader();
}

// src/common/navigation/mega-menu-scroll-lock.js
var initMegaMenuScrollLock = () => {
  const isHeaderSticky = () => {
    const header = document.querySelector(".header");
    if (!header) return false;
    return getComputedStyle(header).getPropertyValue("--header-is-sticky") === "1";
  };
  const lockScroll = () => {
    if (!isHeaderSticky()) {
      document.documentElement.classList.add("lock");
    }
  };
  const unlockScroll = () => {
    document.documentElement.classList.remove("lock");
  };
  const megaMenus = document.querySelectorAll("header-mega-menu");
  if (megaMenus.length === 0) return;
  megaMenus.forEach((menu) => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "attributes" && mutation.attributeName === "open") {
          if (menu.hasAttribute("open")) {
            lockScroll();
            window.StretchCustom?.CustomBackdrop?.show();
          } else {
            unlockScroll();
            window.StretchCustom?.CustomBackdrop?.hide();
          }
        }
      });
    });
    observer.observe(menu, {
      attributes: true,
      attributeFilter: ["open"]
    });
  });
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initMegaMenuScrollLock);
} else {
  initMegaMenuScrollLock();
}

// src/common/navigation/menu-drawer-close-button.js
var initMenuDrawerCloseButton = () => {
  const menuDrawer = document.getElementById("menu-drawer");
  if (!menuDrawer) return;
  const closeButton = menuDrawer.querySelector(".menu-drawer__close");
  if (!closeButton) return;
  closeButton.addEventListener("click", () => {
    menuDrawer.hide();
  });
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initMenuDrawerCloseButton);
} else {
  initMenuDrawerCloseButton();
}

// src/common/navigation/menu-promo-video-buttons.js
var initMenuPromoVideoButtons = () => {
  document.querySelectorAll(".menu-promo__video-btn").forEach((btn) => {
    const video = btn.closest(".menu-promo__video-wrapper")?.querySelector("video");
    if (!video) return;
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (video.paused) {
        video.play();
        btn.setAttribute("data-state", "playing");
        btn.setAttribute("aria-label", "Pause video");
      } else {
        video.pause();
        btn.setAttribute("data-state", "paused");
        btn.setAttribute("aria-label", "Play video");
      }
    });
  });
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initMenuPromoVideoButtons);
} else {
  initMenuPromoVideoButtons();
}

// src/common/product/variant-robot.js
(function() {
  const DRAWER_ID = "variant-robot-drawer";
  const DEFAULT_HEADER_TEXT = "All colors";
  function openDrawer(products) {
    if (!Array.isArray(products) || products.length === 0) return;
    const drawer = document.getElementById(DRAWER_ID);
    if (!drawer || typeof drawer.show !== "function") return;
    const wrapper = document.createElement("div");
    wrapper.className = "vr-drawer-colors";
    wrapper.setAttribute("data-vr-drawer", "1");
    const activeIndex = products.findIndex(function(p) {
      return p && p.is_active;
    });
    const orderedProducts = activeIndex > 0 ? [products[activeIndex]].concat(products.slice(0, activeIndex), products.slice(activeIndex + 1)) : products;
    for (const p of orderedProducts) {
      const hex = p.color_hex && String(p.color_hex).trim() ? p.color_hex : "#9e9e9e";
      const colorName = p.color_name != null ? String(p.color_name).trim() : "";
      const url = p.url != null ? String(p.url) : "#";
      const title = p.title != null ? String(p.title) : "";
      const a = document.createElement("a");
      a.className = "vr-drawer-colors__link";
      a.href = url;
      a.title = title;
      a.setAttribute("aria-label", title);
      const swatchWrap = document.createElement("div");
      swatchWrap.className = "vr-drawer-colors__swatch-wrap" + (p.is_active ? " vr-drawer-colors__swatch-wrap--active" : "");
      const swatch = document.createElement("span");
      swatch.className = "vr-drawer-colors__swatch";
      swatch.style.backgroundColor = hex;
      swatch.setAttribute("aria-hidden", "true");
      swatchWrap.appendChild(swatch);
      a.appendChild(swatchWrap);
      const nameEl = document.createElement("span");
      nameEl.className = "vr-drawer-colors__color-name";
      const displayName = colorName || (title.includes(" - ") ? title.split(" - ").pop().trim() : title);
      nameEl.textContent = displayName;
      a.appendChild(nameEl);
      wrapper.appendChild(a);
    }
    const header = document.createElement("span");
    header.className = "h5";
    header.slot = "header";
    header.textContent = DEFAULT_HEADER_TEXT;
    drawer.replaceChildren(header, wrapper);
    drawer.show();
  }
  document.addEventListener("click", function(e) {
    const btn = e.target.closest("[data-vr-open-drawer]");
    if (!btn) return;
    const root = btn.closest(".vr-linked-products");
    if (!root) return;
    const raw = root.getAttribute("data-vr-products");
    if (!raw) return;
    e.preventDefault();
    e.stopPropagation();
    try {
      const products = JSON.parse(raw);
      openDrawer(products);
    } catch (_) {
    }
  }, true);
})();

// src/common/product/sticky-scroll-to-cart.js
import { mediaQueryListener as mediaQueryListener2 } from "theme";
var initStickyScrollToCart = () => {
  const bars = document.querySelectorAll("[data-sticky-scroll-to-cart]:not([data-sticky-scroll-inited])");
  if (bars.length === 0) return;
  const endMarker = document.querySelector(".shopify-section--footer");
  bars.forEach((bar) => {
    bar.setAttribute("data-sticky-scroll-inited", "true");
    const scrollTargetId = bar.getAttribute("data-scroll-target");
    const form = scrollTargetId ? document.getElementById(scrollTargetId) : null;
    if (!form) return;
    const slot = bar.querySelector("[data-sticky-scroll-clone-slot]");
    if (!slot) return;
    let isStartOutOfView = false;
    let isEndInView = false;
    const isMobile = () => window.matchMedia("(max-width: 699px)").matches;
    const updateVisibility = () => {
      const visible = isStartOutOfView && !isEndInView && isMobile();
      bar.classList.toggle("is-visible", visible);
      bar.setAttribute("aria-hidden", visible ? "false" : "true");
      document.documentElement.classList.toggle(
        "has-sticky-choose-size",
        Boolean(document.querySelector("[data-sticky-scroll-to-cart].is-visible"))
      );
    };
    mediaQueryListener2("sm-max", () => updateVisibility());
    const getOriginalButton = () => form.querySelector(".add-to-cart-button");
    const scrollToOriginal = () => {
      const original = getOriginalButton();
      if (original) original.scrollIntoView({ behavior: "smooth", block: "center" });
      else form.scrollIntoView({ behavior: "smooth", block: "center" });
    };
    const injectClone = () => {
      const original = getOriginalButton();
      slot.innerHTML = "";
      if (!original) return;
      const clone = original.cloneNode(true);
      clone.setAttribute("type", "button");
      clone.removeAttribute("form");
      const label = bar.getAttribute("data-sticky-label");
      const textEl = clone.querySelector(".add-to-cart-button__text");
      const isPurchaseButton = !original.disabled && original.type === "submit";
      if (label && textEl && isPurchaseButton) {
        textEl.textContent = label;
      }
      clone.setAttribute("aria-label", textEl?.textContent?.trim() || label || "Scroll to Add to cart");
      clone.classList.add("js-sticky-scroll-clone");
      clone.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        scrollToOriginal();
      });
      slot.appendChild(clone);
    };
    injectClone();
    form.addEventListener("product:rerender", () => {
      setTimeout(injectClone, 0);
    });
    const startObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target !== form) return;
        isStartOutOfView = !entry.isIntersecting;
        updateVisibility();
      });
    }, { threshold: 0, rootMargin: "0px" });
    startObserver.observe(form);
    if (endMarker) {
      const endObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target !== endMarker) return;
          isEndInView = entry.isIntersecting && entry.boundingClientRect.top < window.innerHeight;
          updateVisibility();
        });
      }, { threshold: 0, rootMargin: "0px" });
      endObserver.observe(endMarker);
    }
    const rect = form.getBoundingClientRect();
    isStartOutOfView = rect.bottom < 0 || rect.top > window.innerHeight;
    if (endMarker) {
      const endRect = endMarker.getBoundingClientRect();
      isEndInView = endRect.top < window.innerHeight && endRect.bottom > 0;
    }
    updateVisibility();
  });
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initStickyScrollToCart);
} else {
  initStickyScrollToCart();
}
document.addEventListener("shopify:section:load", () => initStickyScrollToCart());

// src/common/product/carousel-nudge.js
var initCarouselNudge = () => {
  const nudgeCards = document.querySelectorAll(".product-card--nudge");
  if (!nudgeCards.length) return;
  const easeInOutSine2 = (t) => -(Math.cos(Math.PI * t) - 1) / 2;
  const animateScroll2 = (carousel, from, to, duration, onComplete) => {
    const start = performance.now();
    const step = (now) => {
      const t = Math.min((now - start) / duration, 1);
      carousel.scrollLeft = from + (to - from) * easeInOutSine2(t);
      if (t < 1) {
        requestAnimationFrame(step);
      } else if (onComplete) {
        onComplete();
      }
    };
    requestAnimationFrame(step);
  };
  const runNudge2 = (carousel) => {
    const nudgeDistance = carousel.clientWidth * 0.6;
    carousel.classList.add("is-nudging");
    animateScroll2(carousel, 0, nudgeDistance, 550, () => {
      setTimeout(() => {
        animateScroll2(carousel, nudgeDistance, 0, 480, () => {
          carousel.classList.remove("is-nudging");
        });
      }, 160);
    });
  };
  nudgeCards.forEach((card) => {
    const carousel = card.querySelector("scroll-carousel");
    if (!carousel) return;
    const cells = carousel.querySelectorAll(".product-card__media-item");
    if (cells.length <= 1) return;
    const observer = new IntersectionObserver((entries, obs) => {
      if (!entries[0].isIntersecting) return;
      obs.disconnect();
      const wrapper = carousel.closest(".product-card__media-wrapper");
      const carouselDisabledHere = wrapper && wrapper.classList.contains("product-card__media-wrapper--disable-carousel-mobile") && window.matchMedia("(max-width: 699px)").matches;
      if (carouselDisabledHere) return;
      setTimeout(() => runNudge2(carousel), 600);
    }, { threshold: 0.6 });
    observer.observe(card);
  });
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCarouselNudge);
} else {
  initCarouselNudge();
}

// src/common/product/product-gallery-video-buttons.js
var initProductGalleryVideoButtons = () => {
  document.querySelectorAll(".product-gallery__video-btn").forEach((btn) => {
    const wrapper = btn.closest(".product-gallery__video-wrapper");
    const videoMedia = wrapper?.querySelector("video-media");
    if (!videoMedia) return;
    const setButtonState = (playing) => {
      btn.setAttribute("data-state", playing ? "playing" : "paused");
      btn.setAttribute("aria-label", playing ? "Pause video" : "Play video");
    };
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const playing = videoMedia.hasAttribute("playing");
      if (playing) {
        videoMedia.pause();
        setButtonState(false);
      } else {
        videoMedia.play();
        setButtonState(true);
      }
    });
    const video = videoMedia.querySelector("video");
    if (video) {
      video.addEventListener("play", () => setButtonState(true));
      video.addEventListener("pause", () => setButtonState(false));
    }
    const observer = new MutationObserver(() => {
      setButtonState(videoMedia.hasAttribute("playing"));
    });
    observer.observe(videoMedia, { attributes: true, attributeFilter: ["playing"] });
    setButtonState(videoMedia.hasAttribute("playing"));
  });
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initProductGalleryVideoButtons);
} else {
  initProductGalleryVideoButtons();
}

// src/common/product/quick-buy-vr-swap.js
import { cachedFetch } from "theme";
var initQuickBuyVRSwap = () => {
  document.addEventListener("click", async (e) => {
    const vrLink = e.target.closest("a.vr-linked-product, .vr-drawer-colors__link");
    if (!vrLink || !vrLink.href || vrLink.href === "#") return;
    let modal = vrLink.closest("quick-buy-modal");
    if (!modal) {
      const inDrawer = vrLink.closest("#variant-robot-drawer");
      if (inDrawer) {
        modal = document.querySelector("quick-buy-modal[open]");
      }
    }
    if (!modal) return;
    e.preventDefault();
    e.stopPropagation();
    const vrDrawer = document.getElementById("variant-robot-drawer");
    if (vrDrawer && typeof vrDrawer.hide === "function" && vrDrawer.hasAttribute("open")) {
      vrDrawer.hide();
    }
    const productUrl = vrLink.href;
    modal.setAttribute("aria-busy", "true");
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    try {
      const html = await (await cachedFetch(productUrl)).text();
      const tempDoc = new DOMParser().parseFromString(html, "text/html");
      const quickBuyContent = tempDoc.getElementById("quick-buy-content");
      if (!quickBuyContent) return;
      modal.replaceChildren(quickBuyContent.content.cloneNode(true).firstElementChild);
      modal.setAttribute("product-url", productUrl);
    } finally {
      modal.setAttribute("aria-busy", "false");
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    }
  });
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initQuickBuyVRSwap);
} else {
  initQuickBuyVRSwap();
}

// src/common/product/quick-buy-modal-close.js
var initQuickBuyModalClose = () => {
  document.addEventListener("variant:add", () => {
    const modal = document.querySelector("quick-buy-modal[open]");
    if (modal) {
      modal.hide();
    }
  });
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initQuickBuyModalClose);
} else {
  initQuickBuyModalClose();
}

// src/common/product/variant-picker-stock-information.js
var COUNT_PLACEHOLDER = "__COUNT__";
var FALLBACK_TEMPLATE = "{{ count }} left in stock";
function resolveTemplate() {
  const t = window.themeVariables?.strings?.leftInStockTemplate;
  if (typeof t === "string" && t.length > 0) return t;
  return FALLBACK_TEMPLATE;
}
function formatLeftInStock(count) {
  const template = resolveTemplate();
  return template.replace(COUNT_PLACEHOLDER, String(count)).replace("{{ count }}", String(count)).replace("{{count}}", String(count));
}
function readStockMap(variantPicker) {
  const node = variantPicker.querySelector("script[data-stock-map]");
  if (!node) return null;
  try {
    const raw = node.textContent;
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}
function getInventoryQuantity(variantPicker, variant) {
  if (!variant) return null;
  if (typeof variant.inventory_quantity === "number") {
    return variant.inventory_quantity;
  }
  const map = readStockMap(variantPicker);
  if (!map) return null;
  const qty = map[variant.id];
  return typeof qty === "number" ? qty : null;
}
function updateStockInfo(variantPicker, variant) {
  const nodes = variantPicker.querySelectorAll("[data-stock-info]");
  if (nodes.length === 0) return;
  const threshold = Number(variantPicker.dataset.lowStockThreshold || 0);
  const qty = getInventoryQuantity(variantPicker, variant);
  const show = threshold > 0 && qty != null && qty > 0 && qty < threshold;
  nodes.forEach((node) => {
    if (show) {
      const textEl = node.querySelector("[data-stock-info-text]");
      if (textEl) textEl.textContent = formatLeftInStock(qty);
      node.hidden = false;
    } else {
      node.hidden = true;
    }
  });
}
function readInitialVariant(variantPicker) {
  const payload = variantPicker.querySelector("script[data-variant]");
  if (!payload) return null;
  try {
    const raw = payload.textContent;
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}
function initVariantPicker(variantPicker) {
  if (variantPicker.__stretchStockInfoInit) return;
  variantPicker.__stretchStockInfoInit = true;
  const initialVariant = readInitialVariant(variantPicker);
  if (initialVariant) updateStockInfo(variantPicker, initialVariant);
}
function handleVariantChange(event) {
  const variant = event.detail?.variant;
  if (!variant) return;
  const form = event.target;
  const formId = form && typeof form.getAttribute === "function" ? form.getAttribute("id") : null;
  if (!formId) return;
  const variantPicker = document.querySelector(
    `variant-picker[form-id="${CSS.escape(formId)}"]`
  );
  if (!variantPicker) return;
  updateStockInfo(variantPicker, variant);
}
function init() {
  document.querySelectorAll("variant-picker").forEach(initVariantPicker);
  document.addEventListener("variant:change", handleVariantChange);
  document.addEventListener("shopify:section:load", () => {
    document.querySelectorAll("variant-picker").forEach(initVariantPicker);
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}

// src/common/product/size-guide-table-scroll.js
var easeInOutSine = (t) => -(Math.cos(Math.PI * t) - 1) / 2;
var animateScroll = (el, from, to, duration, onComplete) => {
  const start = performance.now();
  const step = (now) => {
    const t = Math.min((now - start) / duration, 1);
    el.scrollLeft = from + (to - from) * easeInOutSine(t);
    if (t < 1) {
      requestAnimationFrame(step);
    } else if (onComplete) {
      onComplete();
    }
  };
  requestAnimationFrame(step);
};
var runNudge = (scroller) => {
  if (scroller.scrollWidth <= scroller.clientWidth) return;
  const nudgeDistance = Math.min(scroller.clientWidth * 0.15, 60);
  animateScroll(scroller, 0, nudgeDistance, 480, () => {
    setTimeout(() => {
      animateScroll(scroller, nudgeDistance, 0, 400, null);
    }, 120);
  });
};
var initSizeGuideTableScroll = () => {
  document.querySelectorAll(".drawer .prose .table-scroller").forEach((scroller) => {
    let hasNudged = false;
    const updateFade = () => {
      const atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 4;
      scroller.classList.toggle("is-scrolled-end", atEnd);
    };
    scroller.addEventListener("scroll", updateFade, { passive: true });
    const drawer = scroller.closest("x-drawer");
    if (!drawer) return;
    new MutationObserver(() => {
      if (!drawer.hasAttribute("open")) return;
      requestAnimationFrame(updateFade);
      if (!hasNudged) {
        hasNudged = true;
        setTimeout(() => runNudge(scroller), 550);
      }
    }).observe(drawer, { attributes: true, attributeFilter: ["open"] });
  });
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initSizeGuideTableScroll);
} else {
  initSizeGuideTableScroll();
}

// src/common/product/klaviyo-bis-form.js
var KLAVIYO_REVISION = "2024-10-15";
var strings = () => window.themeVariables?.strings || {};
var isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
var KlaviyoBisForm = class extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector("form");
    this.statusEl = this.querySelector("[data-bis-status]");
    this.submitButton = this.form?.querySelector('[type="submit"]');
    this.onSubmit = this.handleSubmit.bind(this);
    this.form?.addEventListener("submit", this.onSubmit);
    const modal = this.closest("x-modal");
    if (modal?.id) {
      document.querySelectorAll(`x-modal#${CSS.escape(modal.id)}`).forEach((el) => {
        if (el !== modal) el.remove();
      });
    }
  }
  disconnectedCallback() {
    this.form?.removeEventListener("submit", this.onSubmit);
  }
  get variantId() {
    const formId = this.getAttribute("observe-form");
    return document.forms[formId]?.querySelector('[name="id"]')?.value || "";
  }
  get companyId() {
    return window.themeVariables?.settings?.klaviyoPublicKey || "";
  }
  get newsletterListId() {
    return window.themeVariables?.settings?.klaviyoNewsletterListId || "";
  }
  postToKlaviyo(companyId, endpoint, body) {
    return fetch(`https://a.klaviyo.com/client/${endpoint}/?company_id=${encodeURIComponent(companyId)}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        revision: KLAVIYO_REVISION
      },
      body: JSON.stringify(body)
    });
  }
  async subscribeToNewsletter(companyId, email) {
    const listId = this.newsletterListId;
    if (!listId) {
      console.warn("Klaviyo newsletter list ID is missing; skipped marketing subscribe.");
      return;
    }
    try {
      const subscribeResponse = await this.postToKlaviyo(companyId, "subscriptions", {
        data: {
          type: "subscription",
          attributes: {
            custom_source: "Back in Stock",
            profile: {
              data: {
                type: "profile",
                attributes: { email }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: listId
              }
            }
          }
        }
      });
      if (!subscribeResponse.ok && subscribeResponse.status !== 202) {
        console.warn(`Klaviyo subscribe failed: ${subscribeResponse.status}`);
      }
    } catch (subscribeError) {
      console.warn(subscribeError);
    }
  }
  setStatus(message, isError = false) {
    if (!this.statusEl) return;
    this.statusEl.hidden = !message;
    this.statusEl.textContent = message || "";
    this.statusEl.classList.toggle("text-error", Boolean(isError));
  }
  async handleSubmit(event) {
    event.preventDefault();
    const email = (this.form.querySelector('[name="email"]')?.value || "").trim();
    if (!isValidEmail(email)) {
      this.setStatus(strings().backInStockInvalidEmail || "Enter a valid email address.", true);
      return;
    }
    const variantId = this.variantId;
    const companyId = this.companyId;
    if (!variantId || !companyId) {
      this.setStatus(strings().backInStockError || "Something went wrong. Please try again.", true);
      return;
    }
    const subscribeNewsletter = this.form.querySelector('[name="newsletter"]')?.checked === true;
    this.submitButton?.setAttribute("aria-busy", "true");
    this.setStatus("");
    try {
      const response = await this.postToKlaviyo(
        companyId,
        "back-in-stock-subscriptions",
        {
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              channels: ["EMAIL"],
              profile: {
                data: {
                  type: "profile",
                  attributes: { email }
                }
              }
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: `$shopify:::$default:::${variantId}`
                }
              }
            }
          }
        }
      );
      if (!response.ok && response.status !== 202) {
        throw new Error(`Klaviyo BIS failed: ${response.status}`);
      }
      if (subscribeNewsletter) {
        await this.subscribeToNewsletter(companyId, email);
      }
      this.setStatus(strings().backInStockSuccess || "Thanks. We will let you know when it is back.");
      this.form.reset();
    } catch (error) {
      console.warn(error);
      this.setStatus(strings().backInStockError || "Something went wrong. Please try again.", true);
    } finally {
      this.submitButton?.removeAttribute("aria-busy");
    }
  }
};
if (!window.customElements.get("klaviyo-bis-form")) {
  window.customElements.define("klaviyo-bis-form", KlaviyoBisForm);
}

// src/common/product/judgeme-badge-link.js
var BADGE_SELECTOR = ".jdgm-preview-badge, .jdgm-prev-badge";
var getReviewsUrl = () => {
  const settings = window.themeVariables?.settings;
  if (!settings || settings.pageType !== "product") return "";
  const { shopDomain, productHandle } = settings;
  if (!shopDomain || !productHandle) return "";
  return `https://judge.me/reviews/stores/${shopDomain}/products/${productHandle}`;
};
var wrapBadge = (badge) => {
  if (badge.closest("a.rating-badge-link")) return;
  const url = getReviewsUrl();
  if (!url) return;
  const block = badge.closest(".shopify-block, .shopify-app-block") || badge;
  if (block.closest("a.rating-badge-link") || !block.parentNode) return;
  const link = document.createElement("a");
  link.className = "rating-badge-link";
  link.href = url;
  link.target = "_blank";
  link.rel = "noopener noreferrer";
  block.parentNode.insertBefore(link, block);
  link.appendChild(block);
  block.addEventListener("click", (event) => {
    event.stopPropagation();
  }, true);
};
var scan = () => {
  document.querySelectorAll(BADGE_SELECTOR).forEach(wrapBadge);
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", scan);
} else {
  scan();
}
new MutationObserver(scan).observe(document.documentElement, {
  childList: true,
  subtree: true
});

// src/common/carousel/complementary-next-button.js
var initComplementaryCarouselNextButtonAtEnd = () => {
  const THRESHOLD = 2;
  const updateNextButton = (carousel) => {
    const nextBtn = carousel.closest("product-recommendations")?.querySelector(`carousel-next-button[aria-controls="${carousel.id}"]`);
    const button = nextBtn?.firstElementChild;
    if (!button) return;
    const maxScroll = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
    button.disabled = carousel.scrollLeft >= maxScroll - THRESHOLD;
  };
  const attachToCarousel = (carousel) => {
    if (carousel._complementaryNextButtonPatched) return;
    carousel._complementaryNextButtonPatched = true;
    let tick = false;
    const onScroll = () => {
      if (tick) return;
      tick = true;
      requestAnimationFrame(() => {
        tick = false;
        updateNextButton(carousel);
      });
    };
    carousel.addEventListener("scroll", onScroll, { passive: true });
    updateNextButton(carousel);
  };
  const observeCarousels = () => {
    document.querySelectorAll("product-recommendations scroll-carousel.complementary-products").forEach(attachToCarousel);
  };
  observeCarousels();
  document.querySelectorAll("product-recommendations").forEach((el) => {
    new MutationObserver(observeCarousels).observe(el, { childList: true, subtree: true });
  });
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initComplementaryCarouselNextButtonAtEnd);
} else {
  initComplementaryCarouselNextButtonAtEnd();
}

// src/common/cart/custom-cart-drawer.js
import { CartDrawer } from "theme";
var CustomCartDrawer = class extends CartDrawer {
  /**
   * Called when the cart drawer opens
   * Add custom logic before/after the default behavior
   */
  async open() {
    console.log("\u{1F6D2} Cart drawer opening...");
    document.body.classList.add("custom-cart-open");
    const result = await super.open();
    console.log("\u2705 Cart drawer opened");
    return result;
  }
  /**
   * Called when the cart drawer closes
   */
  async hide() {
    console.log("\u{1F6D2} Cart drawer closing...");
    const result = await super.hide();
    document.body.classList.remove("custom-cart-open");
    console.log("\u2705 Cart drawer closed");
    return result;
  }
  /**
   * You can override other methods too:
   * - connectedCallback() - when element is added to DOM
   * - disconnectedCallback() - when element is removed from DOM
   * - renderFormattedMoney() - custom money formatting
   * - Any other method from the parent CartDrawer class
   * 
   * Always call super.methodName() to preserve theme functionality!
   */
};
customElements.define("custom-cart-drawer", CustomCartDrawer);

// src/sections/announcement-bar-musp.js
import { matchesMediaQuery, mediaQueryListener as mediaQueryListener3 } from "theme";
window.StretchCustom.AnnouncementBarMusp = (function() {
  "use strict";
  let state = {
    rotationInterval: null,
    currentIndex: 0,
    isPaused: false,
    cycleSpeed: 5e3
  };
  const isMobileBreakpoint = () => matchesMediaQuery("sm-max");
  const rotateMuspItems = (items) => {
    if (!isMobileBreakpoint() || state.isPaused) return;
    items[state.currentIndex].classList.remove("is-active");
    state.currentIndex = (state.currentIndex + 1) % items.length;
    items[state.currentIndex].classList.add("is-active");
  };
  const startMuspRotation = (items) => {
    if (!isMobileBreakpoint()) return;
    stopMuspRotation();
    state.rotationInterval = setInterval(() => rotateMuspItems(items), state.cycleSpeed);
  };
  const stopMuspRotation = () => {
    if (state.rotationInterval) {
      clearInterval(state.rotationInterval);
      state.rotationInterval = null;
    }
  };
  const initializeMuspItems = (items) => {
    state.currentIndex = 0;
    items.forEach((item, index) => {
      if (index === 0) {
        item.classList.add("is-active");
      } else {
        item.classList.remove("is-active");
      }
    });
  };
  const handleMuspResize = (items) => {
    if (isMobileBreakpoint()) {
      items.forEach((item, index) => {
        if (index === state.currentIndex) {
          item.classList.add("is-active");
        } else {
          item.classList.remove("is-active");
        }
      });
      if (!state.isPaused) {
        startMuspRotation(items);
      }
    } else {
      stopMuspRotation();
      items.forEach((item) => item.classList.add("is-active"));
    }
  };
  const initializePauseButton = (pauseBtn, items, announcementBar) => {
    const statusElement = announcementBar.querySelector("[data-rotation-status]");
    pauseBtn.addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation();
      state.isPaused = !state.isPaused;
      this.classList.toggle("is-paused", state.isPaused);
      const newLabel = state.isPaused ? "Resume rotation" : "Pause rotation";
      this.setAttribute("aria-label", newLabel);
      this.setAttribute("aria-pressed", state.isPaused ? "true" : "false");
      if (statusElement) {
        statusElement.textContent = state.isPaused ? "Rotation paused" : "Rotation resumed";
      }
      if (state.isPaused) {
        stopMuspRotation();
      } else {
        startMuspRotation(items);
      }
    });
  };
  const init2 = () => {
    const announcementBar = document.querySelector(".announcement-bar--musp");
    if (!announcementBar) return;
    const items = announcementBar.querySelectorAll(".announcement-bar__musp-item");
    const pauseBtn = announcementBar.querySelector(".announcement-bar__pause-btn");
    if (items.length === 0) return;
    state.cycleSpeed = parseInt(announcementBar.getAttribute("data-cycle-speed")) || 5e3;
    initializeMuspItems(items);
    if (pauseBtn) {
      initializePauseButton(pauseBtn, items, announcementBar);
    }
    handleMuspResize(items);
    mediaQueryListener3("sm-max", () => {
      handleMuspResize(items);
    });
  };
  return {
    init: init2
  };
})();
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    window.StretchCustom.AnnouncementBarMusp.init();
  });
} else {
  window.StretchCustom.AnnouncementBarMusp.init();
}

// src/sections/clarifyx-shop-switch.js
var CxShopSwitch = class extends HTMLElement {
  constructor() {
    super();
    if (window.cxShopSwitchInstance) {
      console.warn("[ClarifyX Shop Switch] Multiple instances detected, using first one");
      return;
    }
    window.cxShopSwitchInstance = this;
    this.cxSettings = this.cxParseSettings();
    this.cxData = this.cxInitializeData();
    this.cxModal = null;
    this.cxTrigger = null;
    this.cxHreflangLinks = [];
    this.cxInitialize();
  }
  cxParseSettings() {
    try {
      return JSON.parse(this.getAttribute("data-cxss-settings") || "{}");
    } catch (e) {
      console.warn("[ClarifyX Shop Switch] Invalid settings:", e);
      return {};
    }
  }
  cxInitializeData() {
    return {
      currentCountry: this.cxSettings.countries?.find((c) => c.is_current_shop) || {},
      cookie: this.cxGetCookie(this.cxSettings.cookieName),
      geoData: null,
      utmParams: this.cxExtractUtmParams()
    };
  }
  cxExtractUtmParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const utmParams = {};
    const utmKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
    utmKeys.forEach((key) => {
      const value = urlParams.get(key);
      if (value) {
        utmParams[key] = value;
      }
    });
    return utmParams;
  }
  cxAddUtmParamsToUrl(url) {
    if (!url || Object.keys(this.cxData.utmParams).length === 0) {
      return url;
    }
    try {
      const urlObj = new URL(url);
      const urlParams = new URLSearchParams(urlObj.search);
      Object.entries(this.cxData.utmParams).forEach(([key, value]) => {
        if (!urlParams.has(key)) {
          urlParams.set(key, value);
        }
      });
      urlObj.search = urlParams.toString();
      return urlObj.toString();
    } catch (e) {
      console.warn("[ClarifyX Shop Switch] Failed to parse URL:", url, e);
      return url;
    }
  }
  cxInitialize() {
    if (!this.cxSettings.enabled || !this.cxSettings.countries?.length) {
      return;
    }
    this.cxFindDrawer();
    this.cxScheduleExternalTriggerSync();
    this.cxAttachListeners();
    this.cxCheckLocation();
    if (this.cxSettings.hreflangManager) {
      this.cxInitializeHreflangManager();
    } else {
      this.cxUpdateCountryLinksWithUtm();
    }
    if (window.Shopify && window.Shopify.designMode) {
      this.cxAttachDesignModeListeners();
    }
  }
  cxFindDrawer() {
    this.cxModal = document.querySelector("#cxss-drawer-shop-switch");
    if (!this.cxModal) {
      console.warn("[ClarifyX Shop Switch] Drawer not found. Make sure the component is properly configured.");
      return;
    }
    this.cxDrawerObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "open" && !this.cxModal.hasAttribute("open")) {
          this.cxSetDismissedCookie();
        }
      });
    });
    this.cxDrawerObserver.observe(this.cxModal, { attributes: true, attributeFilter: ["open"] });
  }
  /** Triggers can exist before/after this element connects (e.g. menu drawer). */
  cxScheduleExternalTriggerSync() {
    const run = () => this.cxSyncExternalTriggers();
    run();
    requestAnimationFrame(run);
    [50, 250, 800].forEach((ms) => setTimeout(run, ms));
  }
  /**
   * Updates header / mobile / footer triggers to match the ClarifyX "current store" row.
   * Flag URL must come from image_url in Liquid (img_url is empty for modern image_picker assets).
   */
  cxSyncExternalTriggers() {
    const current = this.cxData.currentCountry;
    if (!current || !current.country_code) {
      return;
    }
    const flagUrl = typeof current.flag === "string" ? current.flag.trim() : "";
    const triggers = document.querySelectorAll('[aria-controls="cxss-drawer-shop-switch"]');
    triggers.forEach((btn) => {
      const codeEl = btn.querySelector(".cxss-sync-code");
      if (codeEl) {
        codeEl.textContent = current.country_code;
      }
      const labelEl = btn.querySelector(".cxss-mobile-trigger-label");
      if (labelEl && current.title) {
        labelEl.textContent = current.title;
      }
      if (flagUrl) {
        const flagWrap = btn.querySelector(".cxss-mobile-flag");
        if (flagWrap) {
          let flagImg = flagWrap.querySelector("img");
          if (!flagImg) {
            flagImg = document.createElement("img");
            flagImg.loading = "lazy";
            flagImg.alt = "";
            flagWrap.appendChild(flagImg);
          }
          flagImg.src = flagUrl;
          flagImg.removeAttribute("srcset");
        }
      }
    });
    const currentRows = (this.cxSettings.countries || []).filter((c) => c.is_current_shop);
    if (currentRows.length > 1) {
      console.warn("[ClarifyX Shop Switch] Multiple blocks marked as current store; using the first match.");
    }
  }
  cxAttachListeners() {
    document.addEventListener("click", (e) => {
      if (e.target.closest('[data-cx-trigger="shop-switch"]')) {
        this.cxOpenDrawer();
        return;
      }
      const countryItem = e.target.closest(".cxss-country-item");
      if (countryItem) {
        try {
          const selectedDomain = new URL(countryItem.getAttribute("href")).hostname;
          this.cxSetCookie(selectedDomain);
        } catch {
          this.cxSetCookie(this.cxData.currentCountry.domain);
        }
        return;
      }
    });
  }
  cxCheckLocation() {
    const dismissedCookieName = `${this.cxSettings.cookieName}_dismissed`;
    const dismissedCookie = this.cxGetCookie(dismissedCookieName);
    if (dismissedCookie === "true" && !this.cxSettings.testMode) {
      return;
    }
    if (this.cxData.cookie === this.cxData.currentCountry.domain && !this.cxSettings.testMode) {
      return;
    }
    this.cxLoadLocation().then(() => {
      this.cxHandleLocation();
    }).catch(() => {
      console.warn("[ClarifyX Shop Switch] Geolocation failed, using default");
    });
  }
  async cxLoadLocation() {
    try {
      const apiUrl = this.cxSettings.geolocationApiUrl;
      if (!apiUrl) {
        console.warn("[ClarifyX Shop Switch] Geolocation API URL not configured");
        return;
      }
      const response = await fetch(apiUrl);
      const data = await response.json();
      let countryCode = data.country_code2 || data.country_code || data.countryCode;
      let countryName = data.country_name || data.country;
      if (countryCode) {
        countryCode = countryCode.toUpperCase();
        this.cxData.geoData = {
          country_code: countryCode,
          country: countryName || countryCode
        };
        console.log("Geo Data: ", this.cxData.geoData);
      }
    } catch (error) {
      console.warn("[ClarifyX Shop Switch] Geolocation API failed:", error);
    }
  }
  cxHandleLocation() {
    if (!this.cxData.geoData) return;
    const userCountry = this.cxData.geoData.country_code;
    const matchingCountry = this.cxSettings.countries?.find((c) => c.country_code === userCountry);
    const targetCountry = matchingCountry || this.cxSettings.countries?.find((c) => c.default === true);
    if (!targetCountry) {
      return;
    }
    const currentShopCountryCode = this.cxData.currentCountry.country_code;
    const currentShopDomain = this.cxData.currentCountry.domain;
    if (this.cxSettings.manualCurrentCountry && this.cxSettings.manualCurrentCountry.toUpperCase() === userCountry.toUpperCase()) {
      return;
    }
    if (currentShopCountryCode && currentShopCountryCode.toUpperCase() === userCountry.toUpperCase()) {
      return;
    }
    if (currentShopDomain && targetCountry.domain && currentShopDomain === targetCountry.domain) {
      return;
    }
    if (this.cxSettings.mode === "redirect") {
      const currentSearch = new URLSearchParams(window.location.search);
      const utmKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
      utmKeys.forEach((key) => currentSearch.delete(key));
      let redirectUrl = this.cxSettings.hreflangManager ? this.cxResolveCountryUrl(targetCountry) : `https://${targetCountry.domain}${window.location.pathname}`;
      try {
        const urlObj = new URL(redirectUrl);
        currentSearch.forEach((value, key) => {
          if (!urlObj.searchParams.has(key)) {
            urlObj.searchParams.set(key, value);
          }
        });
        redirectUrl = urlObj.toString();
      } catch (e) {
        if (currentSearch.toString()) {
          redirectUrl += `${redirectUrl.includes("?") ? "&" : "?"}${currentSearch.toString()}`;
        }
      }
      redirectUrl = this.cxAddUtmParamsToUrl(redirectUrl);
      window.location.href = redirectUrl;
    } else if (this.cxSettings.mode === "popup" || this.cxSettings.testMode) {
      setTimeout(() => this.cxOpenDrawer(), (this.cxSettings.delaySeconds || 3) * 1e3);
    }
  }
  cxOpenDrawer() {
    if (this.cxModal && typeof this.cxModal.show === "function") {
      this.cxModal.show();
    }
  }
  cxCloseDrawer() {
    if (this.cxModal && typeof this.cxModal.hide === "function") {
      this.cxModal.hide();
    }
  }
  // Keep legacy aliases so any external callers still work
  cxOpenModal() {
    this.cxOpenDrawer();
  }
  cxCloseModal() {
    this.cxCloseDrawer();
  }
  cxSetCookie(domain) {
    const days = this.cxSettings.cookieDays || 30;
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1e3);
    document.cookie = `${this.cxSettings.cookieName}=${domain};expires=${expires.toUTCString()};path=/`;
  }
  cxSetDismissedCookie() {
    const days = this.cxSettings.cookieDays || 30;
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1e3);
    const dismissedCookieName = `${this.cxSettings.cookieName}_dismissed`;
    document.cookie = `${dismissedCookieName}=true;expires=${expires.toUTCString()};path=/`;
  }
  cxGetCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  }
  cxNormalizeHost(value) {
    if (!value) return "";
    try {
      const url = String(value).includes("://") ? value : `https://${value}`;
      return new URL(url).hostname.replace(/^www\./i, "").toLowerCase();
    } catch (e) {
      return String(value).replace(/^www\./i, "").toLowerCase();
    }
  }
  cxShopRootUrl(country) {
    const domain = String(country?.domain || "").replace(/^https?:\/\//i, "").replace(/\/$/, "");
    return domain ? `https://${domain}/` : "/";
  }
  cxCollectHreflangLinks() {
    const links = [];
    document.querySelectorAll("head link[hreflang]").forEach((el) => {
      const hreflang = el.getAttribute("hreflang");
      const href = el.getAttribute("href");
      if (hreflang && href) {
        links.push({ hreflang: hreflang.toLowerCase(), href });
      }
    });
    return links;
  }
  cxHreflangTagMatchesCountry(hreflang, country) {
    const tag = String(hreflang || "").toLowerCase();
    if (!tag || tag === "x-default") return false;
    const codes = [country?.hreflang_code, country?.country_code].filter(Boolean).map((code) => String(code).toLowerCase());
    return codes.some((code) => tag === code || tag.endsWith(`-${code}`));
  }
  cxCountryFromLink(linkEl) {
    const countryCode = linkEl.getAttribute("data-country");
    const hreflangCode = linkEl.getAttribute("data-hreflang");
    const fromSettings = this.cxSettings.countries?.find((country) => {
      if (countryCode && country.country_code === countryCode) return true;
      if (hreflangCode && String(country.hreflang_code || "").toLowerCase() === hreflangCode.toLowerCase()) {
        return true;
      }
      return false;
    });
    if (fromSettings) return fromSettings;
    return {
      country_code: countryCode,
      hreflang_code: hreflangCode,
      domain: (() => {
        try {
          return new URL(linkEl.getAttribute("href") || "", window.location.origin).hostname;
        } catch (e) {
          return "";
        }
      })()
    };
  }
  cxResolveCountryUrl(country) {
    if (!country) return "/";
    const rootUrl = this.cxShopRootUrl(country);
    if (!this.cxSettings.hreflangManager) {
      return country.url || rootUrl;
    }
    const host = this.cxNormalizeHost(country.domain);
    if (host) {
      const hostMatch = this.cxHreflangLinks.find((link) => this.cxNormalizeHost(link.href) === host);
      if (hostMatch) return hostMatch.href;
    }
    const tagMatch = this.cxHreflangLinks.find((link) => this.cxHreflangTagMatchesCountry(link.hreflang, country));
    if (tagMatch) return tagMatch.href;
    return rootUrl;
  }
  cxInitializeHreflangManager() {
    this.cxHreflangLinks = this.cxCollectHreflangLinks();
    this.cxUpdateCountryLinksWithHreflang();
  }
  cxUpdateCountryLinksWithHreflang() {
    if (!this.cxModal) return;
    this.cxModal.querySelectorAll(".cxss-country-item").forEach((link) => {
      const country = this.cxCountryFromLink(link);
      const resolvedUrl = this.cxResolveCountryUrl(country);
      link.setAttribute("href", this.cxAddUtmParamsToUrl(resolvedUrl));
    });
  }
  cxUpdateCountryLinksWithUtm() {
    if (!this.cxModal) return;
    const countryLinks = this.cxModal.querySelectorAll(".cxss-country-item");
    countryLinks.forEach((link) => {
      const currentUrl = link.getAttribute("href");
      const updatedUrl = this.cxAddUtmParamsToUrl(currentUrl);
      link.setAttribute("href", updatedUrl);
    });
  }
  cxAttachDesignModeListeners() {
    this.closest(".shopify-section").addEventListener("shopify:section:select", () => {
      this.cxOpenDrawer();
    });
    this.closest(".shopify-section").addEventListener("shopify:section:deselect", () => {
      this.cxCloseDrawer();
    });
  }
};
if (!customElements.get("clarifyx-shop-switch")) {
  customElements.define("clarifyx-shop-switch", CxShopSwitch);
}

// src/sections/insta-follow-us.js
var INSTAGRAM_ICON_SVG = '<svg class="insta-follow-us-btn__icon" aria-hidden="true" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.4c-2.607 0-2.934.011-3.958.058-1.022.046-1.72.209-2.33.446a4.705 4.705 0 0 0-1.7 1.107 4.706 4.706 0 0 0-1.108 1.7c-.237.611-.4 1.31-.446 2.331C2.41 9.066 2.4 9.392 2.4 12c0 2.607.011 2.934.058 3.958.046 1.022.209 1.72.446 2.33a4.706 4.706 0 0 0 1.107 1.7c.534.535 1.07.863 1.7 1.108.611.237 1.309.4 2.33.446 1.025.047 1.352.058 3.959.058s2.934-.011 3.958-.058c1.022-.046 1.72-.209 2.33-.446a4.706 4.706 0 0 0 1.7-1.107 4.706 4.706 0 0 0 1.108-1.7c.237-.611.4-1.31.446-2.33.047-1.025.058-1.352.058-3.959s-.011-2.934-.058-3.958c-.047-1.022-.209-1.72-.446-2.33a4.706 4.706 0 0 0-1.107-1.7 4.705 4.705 0 0 0-1.7-1.108c-.611-.237-1.31-.4-2.331-.446C14.934 2.41 14.608 2.4 12 2.4Zm0 1.73c2.563 0 2.867.01 3.88.056.935.042 1.443.199 1.782.33.448.174.768.382 1.104.718.336.336.544.656.718 1.104.131.338.287.847.33 1.783.046 1.012.056 1.316.056 3.879 0 2.563-.01 2.867-.056 3.88-.043.935-.199 1.444-.33 1.782a2.974 2.974 0 0 1-.719 1.104 2.974 2.974 0 0 1-1.103.718c-.339.131-.847.288-1.783.33-1.012.046-1.316.056-3.88.056-2.563 0-2.866-.01-3.878-.056-.936-.042-1.445-.199-1.783-.33a2.974 2.974 0 0 1-1.104-.718 2.974 2.974 0 0 1-.718-1.104c-.131-.338-.288-.847-.33-1.783-.047-1.012-.056-1.316-.056-3.879 0-2.563.01-2.867.056-3.88.042-.935.199-1.443.33-1.782.174-.448.382-.768.718-1.104a2.974 2.974 0 0 1 1.104-.718c.338-.131.847-.288 1.783-.33C9.133 4.14 9.437 4.13 12 4.13Zm0 11.07a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 0 1 0 6.4Zm0-8.13a4.93 4.93 0 1 0 0 9.86 4.93 4.93 0 0 0 0-9.86Zm6.276-.194a1.152 1.152 0 1 1-2.304 0 1.152 1.152 0 0 1 2.304 0Z"/></svg>';
var initInstaFollowUs = () => {
  const container = document.getElementById("insta-follow-us");
  if (!container || container.querySelector(".insta-follow-us-btn")) return;
  const href = container.getAttribute("data-href") || "#";
  const title = container.getAttribute("data-insta-follow-us-title") || "ILSEJACOBSEN";
  const heading = document.createElement("h2");
  heading.setAttribute("class", "insta-follow-us__heading");
  heading.textContent = "Instagram";
  const btn = document.createElement("a");
  btn.href = href;
  btn.target = href.startsWith("#") ? "_self" : "_blank";
  btn.rel = href.startsWith("#") ? "" : "noopener";
  btn.setAttribute("class", "insta-follow-us-btn");
  btn.setAttribute("aria-label", "Follow us on Instagram");
  btn.innerHTML = title + " " + INSTAGRAM_ICON_SVG;
  container.appendChild(heading);
  container.appendChild(btn);
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initInstaFollowUs);
} else {
  initInstaFollowUs();
}
//# sourceMappingURL=custom.js.map
